import PropTypes from 'prop-types';
import React from 'react';
import { JobContext } from '../../../contexts/ContextCreator';
import BannerBottomLeft from '../../Icons/JobFilter/BannerBottomLeft';
import BannerBottomRight from '../../Icons/JobFilter/BannerBottomRight';
import BannerLeftOverlap from '../../Icons/JobFilter/BannerLeftOverlap';
import BannerRightOverlap from '../../Icons/JobFilter/BannerRightOverlap';
import BannerTopLeft from '../../Icons/JobFilter/BannerTopLeft';
import BannerLeftTopRight from '../../Icons/JobFilter/BannerTopRight';
import Button from '../../Input/Button/Button';
import InputField from '../../Input/InputField/InputField';
import LocationInput from '../../Input/LocationInput/LocationInput';
import './JobSearchBar.scss';

export default class JobSearchBar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            location: {
                coordinates: {
                    lat: props.lat,
                    lng: props.lng,
                },
                value: props.location,
                remote: false,
            },
            keywords: props.keywords,
        };
    }

    static propTypes = {
        /**
         * title text to display on the search bar
         */
        searchBarTitle: PropTypes.string,
        /**
         * placeholder for search input
         */
        searchTermPlaceholder: PropTypes.string,
        /**
         * keyword for search
         */
        keywords: PropTypes.string,
        /**
         * location for search
         */
        location: PropTypes.string,
        /**
         * latitude
         */
        lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * longitude
         */
        lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * ref
         */
        refs: PropTypes.func,
        /**
         * Optional value to set if we are searching for a specific company
         */
        companyUrl: PropTypes.string,
    };

    static defaultProps = {
        searchBarTitle: '',
        searchTermPlaceholder: 'Job title, Keywords, Company',
        keywords: '',
        location: '',
        lat: null,
        lng: null,
    };

    static contextType = JobContext;

    onKeywordsChange = (keywords) => {
        this.setState({ keywords: keywords });
    };

    onLocationChange = (location) => {
        this.setState({ location: location });
    };

    handleSubmit() {
        const { keywords, location } = this.state;
        const { companyUrl } = this.props;

        return this.context.searchForJobs(keywords, location, companyUrl);
    }

    renderBanner = () => {
        const { searchBarTitle } = this.props;
        const headerSml = 'headerSml';
        return (
            <React.Fragment>
                <div className={`search-header ${headerSml}`}>
                    {searchBarTitle}
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { keywords, location } = this.state;
        const { searchBarTitle, searchTermPlaceholder } = this.props;
        let containerClasses = searchBarTitle ? '' : 'compact';
        const inputKeywordValue = keywords || '';
        const inputLocationValue = location.value || '';
        containerClasses += 'fullBanner';

        return (
            <div className={`component-JobV3-JobSearchBar ${containerClasses}`}>
                {this.renderBanner()}
                <form
                    ref="search-form"
                    method="get"
                    action="/jobs/find"
                    className="form"
                >
                    <InputField
                        onChange={this.onKeywordsChange}
                        value={inputKeywordValue}
                        name="keywords"
                        placeholder={searchTermPlaceholder}
                        classname="pt-2 boldText"
                        icon={'magnifying-glass'}
                    />
                    <LocationInput
                        onChange={this.onLocationChange}
                        value={inputLocationValue}
                        name="location"
                        placeholder="City, State or Country"
                        className="pt-2 boldText"
                        hasIcon={true}
                        icon={'new-location'}
                    />
                    <Button
                        type="solid"
                        name="search"
                        formAction="submit"
                        value="Find jobs"
                        hover="no-hover-style"
                        onClick={(e) => {
                            e.preventDefault();
                            return this.handleSubmit();
                        }}
                    />
                </form>
            </div>
        );
    }
}
